import { clearQueryCache } from '../../api/queryCache';
// Client-side session for the 供应商管理模块. The token is minted + verified by the
// backend (real isolation); here we only persist it and read who is logged in.

export type SupplierRole = 'supplier' | 'team';

export interface SupplierInfo {
    id: number;
    name: string;
    [key: string]: unknown;
}

export interface SupplierSession {
    token: string;
    role: SupplierRole;
    supplier: SupplierInfo | null;
}

const SESSION_KEY = 'supplier_portal_session';

export function getSupplierSession(): SupplierSession | null {
    try {
        const raw = localStorage.getItem(SESSION_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (parsed && typeof parsed.token === 'string' && (parsed.role === 'supplier' || parsed.role === 'team')) {
            return parsed as SupplierSession;
        }
    } catch {
        // ignore malformed storage
    }
    return null;
}

export function getSupplierToken(): string | null {
    return getSupplierSession()?.token ?? null;
}

export function storeSupplierSession(session: SupplierSession) {
    clearQueryCache();
    localStorage.setItem(SESSION_KEY, JSON.stringify(session));
}

export function clearSupplierSession() {
    clearQueryCache();
    localStorage.removeItem(SESSION_KEY);
}
